function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Top-Bar-Admin",
  transform: "translate(-983.000000, -18.000000)",
  fill: "#177ACC",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(888.000000, 12.000000)"
}, React.createElement("path", {
  d: "M102,14.9047619 C104.33625,14.9047619 109,16.1210101 109,18.5353535 L109,18.5353535 L109,19.9706347 C106.990202,21.9902116 104.623306,23 101.899312,23 C99.175317,23 96.8755465,22.0293727 95,20.0881182 L95,20.0881182 L95,18.5353535 C95,16.1210101 99.66375,14.9047619 102,14.9047619 Z M102,6 C104.046702,6 105.705882,7.6309627 105.705882,9.64285714 C105.705882,11.6547516 104.046702,13.2857143 102,13.2857143 C99.9532977,13.2857143 98.2941176,11.6547516 98.2941176,9.64285714 C98.2941176,7.6309627 99.9532977,6 102,6 Z",
  id: "Combined-Shape"
}))));

var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.a6448066.svg";
export { ForwardRef as ReactComponent };